import type { IFilterValue } from 'entities/Contacts/api/filterTypes.ts'
import { type FilterItem } from 'widgets/FilterEditor/model'

export const IntegrationKeys = new Set(['workflows.integration_id'])

export const isIntegrationWidget = <T extends IFilterValue, C>(filterItem: FilterItem<T, C>) =>
  IntegrationKeys.has(filterItem.key)
